import isFunction from 'onyx-common/isFunction'

const delayResolve = (cb, ms = 1000) => {
  return new Promise(resolve => {
    setTimeout(() => {
      const normalizeCb = isFunction(cb) ? cb : () => cb
      resolve(normalizeCb())
    }, ms)
  })
}

export default delayResolve
